<template>
    <BreadCrumb PageTitle="Modifier une règle" />
    <EditRuleSet />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditRuleSet from "@/components/RulesSet/EditRuleSet.vue";

export default defineComponent({
    name: "EditRuleSetPage",
    components: {
        BreadCrumb,
        EditRuleSet,
    },
});
</script>